import moment from 'moment';
import { ApplicationData, Mode } from './application-data';
import { Validator } from './validator';
import { Country } from '@/client/models';

export class WelcomeValidator implements Validator {
    private countries: Country[];

    constructor() {
        this.initialize = this.initialize.bind(this);
        this.validate = this.validate.bind(this);
    }

    public validate(data: ApplicationData): boolean {
        if (data.child.dateOfBirth == null || data.startAt == null) {
            return false;
        }

        if (data.child.dateOfBirth.isBefore(moment.now()) && data.child.firstName == null) {
            return false;
        }

        if (data.mode === Mode.new && !this.isZipCodeValid(data.country, data.zipCode)) {
            return false;
        }

        return data.child.dateOfBirth.isBefore(data.startAt);
    }

    private isZipCodeValid(countryId: string, zipCode?: string): boolean {
        const country = this.countries?.find(c => c.countryId === countryId);
        if (!country || !country.postcodePattern) {
            return true;
        }

        const requiresZip = country.code.toLowerCase() === 'nl';
        if (!requiresZip && !zipCode) {
            return true;
        }

        return new RegExp(country.postcodePattern).test(zipCode ?? '');
    }

    public initialize(countries: Country[]): void {
        this.countries = countries;
    }
}
